import store from "@/store";

export default function checkFlag(feature) {
  return async (to, from, next) => {
    if (await store.dispatch("feature_flags/check", feature)) {
      next();
    } else {
      store.commit("sendMessage", {
        text: "Funcionalidade temporariamente desativada",
      });
      return next("/");
    }
  };
}
